<div class="custom-snackbar">
  <mat-icon [class]="data.icon">{{data.iconName}}</mat-icon>
  <span>{{data.message}}</span>
</div>
